import React from "react";
import { DineInTableTile as TileData, formatElapsed } from "./dineInBoardBuilder";
import { DINE_IN_TABLE_STATE_META } from "./dineInBoardStatusDefs";
import "./styles/DineInBoardStates.css";
import "./styles/DineInTableTile.css";

interface DineInTableTileProps {
  tile: TileData;
  /** Clock supplied by the board so every tile's elapsed time ticks together. */
  now: number;
  onOpen: (tableNumber: number) => void;
}

/**
 * One table on the floor. Free tables are still buttons — tapping one is how
 * staff will eventually seat it — but they read as quiet placeholders rather
 * than competing with tables that actually need attention.
 */
const DineInTableTile: React.FC<DineInTableTileProps> = ({ tile, now, onOpen }) => {
  const meta = DINE_IN_TABLE_STATE_META[tile.state];
  const isFree = tile.state === "free";
  const elapsed = formatElapsed(tile.openedAt, now);

  return (
    <button
      type="button"
      className={`dine-in-tile dine-in-state--${meta.modifier} ${
        isFree ? "dine-in-tile--free" : ""
      }`}
      onClick={() => onOpen(tile.tableNumber)}
      aria-label={
        isFree
          ? `Table ${tile.tableNumber}, free`
          : `Table ${tile.tableNumber}, ${meta.label}, ${tile.plateCount} items, ₹${Math.round(tile.total)}`
      }
    >
      <span className="dine-in-tile__head">
        <span className="dine-in-tile__number">{tile.label}</span>
        {elapsed && <span className="dine-in-tile__elapsed">{elapsed}</span>}
      </span>

      {isFree ? (
        <>
          <span className="dine-in-tile__status">FREE</span>
          <span className="dine-in-tile__hint">Tap to open</span>
        </>
      ) : (
        <>
          <span className="dine-in-tile__status">
            {tile.pendingCount > 0
              ? `${tile.pendingCount} TO ACCEPT`
              : meta.label.toUpperCase()}
          </span>
          <span className="dine-in-tile__total">₹{Math.round(tile.total)}</span>
          <span className="dine-in-tile__hint">
            {tile.plateCount} item{tile.plateCount === 1 ? "" : "s"}
          </span>
        </>
      )}
    </button>
  );
};

export default DineInTableTile;
